// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__HQpaf","label":"Radio_label__3DwYg","checkMark":"Radio_checkMark__Aq3NO","disabled":"Radio_disabled__kWkLp"};